module.exports = __webpack_public_path__ + "static/img/eyey.fae9039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eyey.png
// module id = D/u1
// module chunks = 0